<template>
  <div class="step-container scrollPosition haus-step-2">
    <div class="step-header">
      <h2 class="step-title">Haustyp</h2>
      <p class="step-text">Um welche Art von Haus geht es?</p>
    </div>
    <div class="step-body">
      <div class="box-container">
        <ActionBox
          class="box-item small-icon-w-80"
          text="Einfamilienhaus"
          @click="setHausTyp(10)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8830.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8830_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-80"
          text="Doppelhaushälfte"
          @click="setHausTyp(50)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8140.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8140_white.svg')"
        />
        <ActionBox
          class="box-item small-icon-w-80"
          text="Reihenhaus"
          @click="setHausTyp(60)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8159.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8159_white.svg')"
        />
        <!-- <ActionBox
          class="box-item small-icon-w-80"
          text="Kleingartenhaus oder Wochenendhaus"
          @click="setHausTyp(70)"
          :iconDefault="require('@/assets/icons/Svgs/Gruppe_8188.svg')"
          :iconHover="require('@/assets/icons/Svgs/Gruppe_8188_white.svg')"
        /> -->
      </div>
    </div>
    <div class="step-footer">
      <div class="row">
        <div class="col-md-4 col-sm-4 text-start">
          <button
            class="back-btn"
            @click="goBack()"
          >
            Zurück
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ActionBox from "@/components/shared/ActionBox.vue";
import { saveToStorage } from "@/utils.js";
export default {
  name: "haus-step-2",
  components: {
    ActionBox,
  },
  data() {
    return {
      fields: {
        indexHausTyp: { value: null },
      },
    };
  },
  methods: {
    setHausTyp(index) {
      this.fields.indexHausTyp.value = index;
      saveToStorage(this.fields);
      this.$router.push("/haus-step-3");
    },
    goBack() {
      this.$router.push("/haus-step-1");
    },
  },
  mounted() {
    this.$emit("setStep", "haus", 3);
  },
};
</script>
<style scoped>
.box-item {
  flex-basis: 220px;
  height: 200px;
}
@media only screen and (max-width: 768px) {
  .box-container {
    grid-auto-rows: minmax(150px, auto);
  }
  .box-item {
    height: 100%;
  }
}
</style>
